import { converters } from '../utils/dataConverters';
/**
 * Хук для модификации данных из FormFields, для использования в onSubmit ф-ии формы
 */
export const useModifyFormData = ({ isDevcode }: { isDevcode: boolean }) => {
  /**
   * ф-ия которая подменяет исходный объект с данными на конвертированный(вызвать в onSubmit)
   * @returns объект с преобразованными значениями, ключи те же
   */
  return (data: Record<string, string>) => {
    const newModifiedData = { ...data };
    converters.forEach((converter) => {
      if (converter.name in data) {
        const value = data[converter.name];
        if (!value) return;
        newModifiedData[converter.name] = converter.convertionFunction(value, {
          isDevcode
        });
      }
    });
    return newModifiedData;
  };
};
